import { Link } from "react-router-dom";

function CartSection() {
    return (
        <>
            <br />
            <h2 className="text-center">Cart Items</h2>
            <br />
            <div className="container">
                <div className="row justify-content-center">
                    {Array(3).fill().map(() => (
                        <div className="col-lg-4 col-sm-6 col-md-6">
                            <div className="single-services-card" >
                                <div className="d-flex justify-content-between">
                                    <div className="services-icon">
                                        <img src="https://fiverr-res.cloudinary.com/t_gig_cards_web,q_auto,f_auto/gigs/141908225/original/f31549419bfee810de1db316f53a6ea114440258.png" alt="" />
                                    </div>
                                    <div className="services-user-pic">
                                        <img src="https://templates.hibotheme.com/bixu/default/assets/images/team/team-img-1.png" alt="" />
                                    </div>
                                </div>
                                <Link to="/services-detail">
                                    <h3>House Cleaning</h3>
                                </Link>
                                <p className="d-flex justify-content-between align-items-center">
                                    <span><strong>Price</strong>: $100</span>
                                    <a className="learn-more">5.0(11)</a>
                                </p>
                                <p className="d-flex justify-content-between align-items-center mb-0">
                                    <Link to="/services-detail" className="learn-more">View <i className="flaticon-next"></i></Link>
                                    <a className="learn-more">Delete <i className="fa fa-trash"></i></a>
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <br />
            <br />
            <h2 className="text-center">Finalize & Checkout</h2>
            <br />
            <h3 className="text-center">Total: 300$</h3>
            <br />
            <p className={"text-center"}><Link to={'/checkout'} className="default-btn">Checkout</Link></p>
            <br />
            <br />
        </>
    )
}

export default CartSection